<div class="alert">
    <span class="alert__icon" aria-hidden="true">
        <mat-icon>error_outline</mat-icon>
    </span>

    <div class="alert__content">
        <p class="alert__title primary-cta">{{ title }}</p>
        <p class="alert__message body-1">{{ message }}</p>
    </div>

    <button mat-icon-button class="alert__close" aria-label="Close" type="button" (click)="onClose()">
        <mat-icon aria-hidden="true">close</mat-icon>
    </button>
</div>
